import React from 'react';
import Switch from 'react-switch';
import styled from 'styled-components';

type Props = {
  checked?: boolean;
  checkedText?: string;
  uncheckedText?: string;
  showLabel?: boolean;
  height?: number;
  width?: number;
  className?: string;
} & React.ComponentProps<typeof Switch>;

const Icon = styled.span`
  display: inline-block;
  color: white;
  font-size: 12px;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const ToggleSwitch = ({
  checked,
  onChange,
  checkedText = '有効',
  uncheckedText = '無効',
  showLabel = true,
  height = 22,
  width = 50,
  className,
  ...rest
}: Props) => (
  <Switch
    onChange={onChange}
    checked={checked}
    height={height}
    width={width}
    checkedIcon={showLabel ? <Icon>{checkedText}</Icon> : false}
    uncheckedIcon={showLabel ? <Icon>{uncheckedText}</Icon> : false}
    className={className}
    {...rest}
  />
);

export default styled(ToggleSwitch)``;
